<template>
  <div class="test-component">
    <div v-for="(data, index) in testValues" :key="index" class="flex items-center gap-x-3 mb-4">
      <el-input v-model="data.value" placeholder="输入mac地址" class="flex-1"></el-input>
      <div class="flex items-center w-[50px]">
        <i v-if="testValues.length > 1" class="el-icon-remove cursor-pointer text-red-500 text-xl mr-2"
          @click="testValues.splice(index, 1)"></i>
        <i v-if="index === testValues.length - 1" class="el-icon-circle-plus cursor-pointer text-blue-500 text-xl"
          @click="testValues.push({ value: '' })"></i>
      </div>
    </div>
    <div class="flex items-center justify-end mt-4">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Test",
  props: {
    type: {
      type: String,
      default: "data"
    },
    dataType: {
      type: String,
      default: "uid"
    },
    operator: {
      type: String,
      default: "eq"
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      testConditions: [
        {
          type: 2,
          dataType: "mac",
          operator: this.operator || "equal",
          values: this.values || []
        }
      ],
      testValues: [{ value: "" }]
    };
  },
  methods: {
    confirm() {
      this.testConditions[0].values = this.testValues
        .filter((item) => item.value)
        .map((item) => item.value);
      this.$emit("confirm", { testConditions: this.testConditions });
    }
  }
};
</script>

<style scoped>
.test-component {
  padding: 20px;
}
</style>
